// import { LayoutTree } from '@moxy/next-layout'
import * as Sentry from '@sentry/nextjs'
import type { AppProps } from 'next/app'
import Script from 'next/script'
import React, { useEffect } from 'react'
import { useUser } from 'src/common/hooks/useUser'

import { trackUser } from 'src/common/lib/segment'
import { registerIdentifiedUser } from 'src/common/utils'
import usePersistBundle from 'src/hooks/usePersistBundle'
import { useGetAthleteQuery } from 'src/services/mainAPI'
import { wrapper } from '../store'
import '../styles/globals.css'

function App({ Component, pageProps }: AppProps) {
    usePersistBundle()
    const user = useUser()

    const { refetch, data } = useGetAthleteQuery(user?.userName, {
        skip: user?.userName === undefined
    })

    useEffect(() => {
        if (user !== null && !data) {
            refetch()
        }
        if (user !== null) {
            localStorage.setItem('user:profile', JSON.stringify(user))
            Sentry.setUser({ email: user.email })
            if (typeof window !== 'undefined') {
                trackUser(user)
            }
            registerIdentifiedUser(user)
        } else {
            Sentry.configureScope((scope) => scope.setUser(null))
        }
    }, [user])

    return (
        <>
            <Script
                src="https://kit.fontawesome.com/38137e77b9.js"
                strategy="beforeInteractive"
            />
            <Script
                strategy="afterInteractive"
                src="https://widget.wickedreports.com/v2/3968/wr-1f11c8cdae2a95ce47adbac0a36d57aa.js"
            />
            <Component {...pageProps} />
        </>
    )
}

export default wrapper.withRedux(App)
